import { useState, useEffect } from "react";
import { collection, query, where, limit, onSnapshot } from "firebase/firestore";
import { Autocomplete, Avatar } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function SearchBarMobile() {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [clients, setClients] = useState([]);
  const [unsubscribe, setUnsubscribe] = useState(null);
  const [readCount, setReadCount] = useState(0); // Ajouté
  const navigate = useNavigate();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // 500ms de délai

    // Nettoyer le timeout lors de la mise à jour de searchQuery
    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    let newUnsubscribe;

    if (debouncedSearchQuery.length > 0) {
      const search = query(
        collection(db, "clients"),
        where(
          "searchTerms",
          "array-contains-any",
          debouncedSearchQuery.trim().toLowerCase().split(" ")
        ),
        limit(10)
      );

      newUnsubscribe = onSnapshot(search, (snapshot) => {
        const results = [];
        snapshot.forEach((doc) => {
          results.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setClients(results);
        setReadCount((count) => count + 1); // Augmente le compteur
        console.log(`Nombre de lectures Firestore : ${readCount}`);
      });
    } else {
      setClients([]);
    }

    setUnsubscribe(() => newUnsubscribe);
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [debouncedSearchQuery]);

  const handleChange = async (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSelect = (event, value) => {
    if (value) {
      const client = clients.find(
        (client) => `${client.firstName} ${client.lastName}` === value
      );
      if (client) {
        handleNavigate(client); // Passez `client` en argument
      }
    }
  };

  const handleNavigate = (client) => {
    navigate(`/client/${client.id}`, {
      state: { ...client, docId: client.id }, // Ajoutez cette ligne
    });
  };

  return (
    <div
      style={{
        display: "flex",
        alignContent: "center",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: "15px",
        marginLeft: "0px",
      }}
    >
      <Autocomplete
        freeSolo
        disableClearable
        options={clients.map(
          (client) => `${client.firstName} ${client.lastName}`
        )}
        renderOption={(props, option, { selected }) => {
          // Trouver le client associé à l'option
          const client = clients.find(
            (client) => `${client.firstName} ${client.lastName}` === option
          );
          return (
            <li
              {...props}
              key={client.id}
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #BEBCBC",
              }}
            >
              {client.profilePicture && (
                <Avatar
                  src={client.profilePicture}
                  style={{ marginRight: "10px", width: "40px", height: "40px" }}
                />
              )}
              <div style={{ width: "220px", fontSize: 12 }}>
                {`${client.firstName} ${client.lastName}`}
              </div>
              <div style={{ fontSize: 12 }}>{client.clientIdentifier}</div>

              {/* {option} */}
            </li>
          );
        }}
        renderInput={(params) => (
          <div
            ref={params.InputProps.ref}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              {...params.inputProps}
              onChange={handleChange}
              value={searchQuery}
              placeholder="Search client…"
              style={{
                flex: "0 0 auto",
                width: "270px",
                height: "45px",
                borderRadius: "5px",
                paddingLeft: "10px",
                background: "#FFFFFF",
                border: "1px solid #BEBCBC",

                // width: "270px",
                // height: "45px",
                // borderRadius: "5px",
                // paddingLeft: "10px",
                // background: "#FFFFFF",
                // border: "1px solid #BEBCBC",
              }}
            />
            <div style={{ marginLeft: "5px" }}>
              <SearchIcon />
            </div>
          </div>
        )}
        onChange={handleSelect}
      />

      {/* <Autocomplete
        freeSolo
        disableClearable
        options={clients.map(
          (client) => `${client.firstName} ${client.lastName}`
        )}
        renderInput={(params) => (
          <div
            ref={params.InputProps.ref}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              {...params.inputProps}
              onChange={handleChange}
              value={searchQuery}
              placeholder="Search client…"
              style={{
                width: "270px",
                height: "45px",
                borderRadius: "5px",
                background: "#FFFFFF",
                border: "1px solid #BEBCBC",
              }}
            />
            <SearchIcon />
          </div>
        )}
        onChange={handleSelect}
      /> */}
    </div>
  );
}
